import { render } from "./input.vue?vue&type=template&id=632b8c46"
import script from "./input.vue?vue&type=script&lang=ts"
export * from "./input.vue?vue&type=script&lang=ts"
script.render = render

export default script